import Vue from 'vue'
import baseStyling from 'brave-sass/default.scss'
import initializeStore from 'brave-vuex/initializeStore'
import Router from 'vue-router'
import {PREVIEW_PATH} from 'brave-build/constants'
import initializeI18n from 'brave-i18n/initializeI18n'
import fontFlashPrevention from 'brave-placeholders/fontFlashPrevention'
import VueMobileDetection from "vue-mobile-detection";

import globalComponentInitialization from 'brave-vue/globalComponentInitialization'
import materialDesignInitialization from 'brave-vue/materialDesignInitialization'

Vue.config.productionTip = true
Vue.config.silent = false

/* eslint-disable no-new */
export default function ({MainComponent, routing, messages}) {
  // Routing
  Vue.use(VueMobileDetection);
  Vue.use(Router);
  let finalizedRoutes = generatePreviewBuildRoutes(routing.routes)
  routing.routes = finalizedRoutes
  routing.scrollBehavior = () => {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve({ x: 0, y: 0 })
      }, 200)
    })
  }

  let router = new Router(routing)

  globalComponentInitialization()

  materialDesignInitialization()


  // Internationalization
  let i18n = initializeI18n({messages})

  // Data store
  let store = initializeStore()

  fontFlashPrevention()

  return new Vue({
    el: '#brave-app',
    router,
    i18n,
    store,
    render: h => h(MainComponent)
  })
}

function generatePreviewBuildRoutes (baseRoutes) {
  let previewBuildRoutes = [];
  for (let route of baseRoutes) {
    let previewRoute = Object.assign({}, route)
    previewRoute.path = `${PREVIEW_PATH}${route.path}`
    previewBuildRoutes.push(previewRoute)
  }

  return baseRoutes.concat(previewBuildRoutes)
}



// WEBPACK FOOTER //
// ./lib/brave-vue/root-entry.js